<kin-icon [size]="24" [name]="icon()" />
<p class="label">{{ label() }}</p>
<p class="value">
  {{ value() || value() === 0 ? value() : '--' }}
  @if (perfPercentage(); as perfPercentage) {
    <span class="perf-percentage"> {{ perfPercentage }}% </span>
  }
</p>
